import React, { Component } from "react";
import { withRedux } from "helpers";
import { Form, FlexRow, H1, H2, Button } from "appStyles";
import { SaveProgress, RadioOptions } from "components";
import EditBackground from "../EditBackground";
import "@material/radio/dist/mdc.radio.css";
import "@material/form-field/dist/mdc.form-field.css";
import { css } from "react-emotion";
import { redemptionTypeOptions } from "constants";
import { imageView } from "defaultStates";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  padding: 20px;
  position: relative;
  padding: 1em;
  border-radius: 5px;
  margin-bottom: 3em;
  margin-top: 1em;
`;

class PictureCatalogSettings extends Component {
  state = {
    croppingAspectRatio: "1.0",
    showModal: false,
  };
  constructor(props) {
    super(props);
  }
  update = (field) => (value) => {
    // console.log("updating with field: " + field + " and value: " + value);
    this.props.actions.updateApplication(field, value);
  };

  updateComponent = (component) => {
    const { activeTemplate } = this.props;
    const updatedTemplate = {
      ...this.props.activeTemplate,
    };
    updatedTemplate.components = activeTemplate.components.map((c) =>
      c.componentNumber === component.componentNumber ? component : c
    );
    this.props.actions.updateTemplate(updatedTemplate);
  };
  updateBackgroundColor = (backgroundColor) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      backgroundColor,
    };

    this.props.actions.updateTemplate(updatedTemplate);
  };

  updateBackgroundImage = (url) => {
    // "updating background image");
    let updatedTemplate = this.props.activeTemplate;
    if (url) {
      if (updatedTemplate.backgroundImage === null) {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: imageView(url),
        };
      } else {
        updatedTemplate = {
          ...this.props.activeTemplate,
          backgroundImage: {
            ...this.props.activeTemplate.backgroundImage,
            url,
          },
        };
      }
    } else {
      updatedTemplate = {
        ...this.props.activeTemplate,
        backgroundImage: null,
      };
    }

    this.props.actions.updateTemplate(updatedTemplate);
  };

  renderPageSettings = () => {
    // if (!this.hasDeal()) return null;
    const { activeApp, activeTemplate, activeEditor } = this.props;
    const { croppingAspectRatio } = this.state;
    return (
      <div className={container}>
        <EditBackground
          croppingAspectRatio={croppingAspectRatio}
          update={this.update}
          updateComponent={this.updateComponent}
          pictureCatalogComponent={
            activeTemplate.type === "pictureCatalog"
              ? activeTemplate.components[0]
              : false
          }
          updateBackgroundColor={this.updateBackgroundColor}
          updateBackgroundImage={this.updateBackgroundImage}
          backgroundColor={activeTemplate.backgroundColor}
          backgroundImage={activeTemplate.backgroundImage}
          additionalPageSettings={this.additionalPageSettings}
          appId={activeApp.id}
        />
        <SaveProgress />
      </div>
    );
  };

  updatePageName = (pageName) => {
    const updatedTemplate = {
      ...this.props.activeTemplate,
      pageName,
    };
    this.props.actions.updateTemplate(updatedTemplate);
  };

  addNewSection = () => {
    // if (!this.props.activeTemplate.components[0])
    //   return console.error("addNewSection function is missing component!");

    const updatedComponent = { ...this.props.activeTemplate.components[0] };
    const newSection = {
      header: {
        alignment: 1,
        backgoundColor: "#ffffff",
        bold: true,
        font: "TimesNewRoman",
        fontSize: 28,
        italics: false,
        text: "New Section Header",
        textColor: "#000000",
      },
      images: [],
    };
    if (updatedComponent.view.sections)
      updatedComponent.view.sections.push(newSection);
    else updatedComponent.view.sections = [newSection];

    this.updateComponent(updatedComponent);
    this.props.actions.updateActiveEditor(
      updatedComponent.view.sections.length - 1
    );
  };

  render() {
    const hasNewDeal = this.props.deals.newDeal;
    const {
      deals,
      activeEditor,
      activeApp: { id },
    } = this.props;
    // console.log("deal actions");
    // JSON.stringify(this.props.actions);
    // console.log(this.props.actions);

    const activeDeal = deals[activeEditor];
    return (
      <div>
        {this.renderPageSettings()}
        <Form marginBottom="3em">
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={this.addNewSection}
              style={{
                marginLeft: " 0px",
                marginBottom: "40px",
                display: "inline-flex",
                alignItems: "center",
                textAlign: "center",
                fontSize: "15px",
                lineHeight: "29px",
                borderRadius: "5.5px",
                backgroundColor: "#89d2d3",
                fontWeight: "bold",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                fontStyle: "normal",
                fontStretch: "normal",
                textTransform: "none",
              }}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon>
              Create New Section
            </Button>
          </div>
          {/* <SaveProgress /> */}
        </Form>
      </div>
    );
  }
}

export default withRedux(PictureCatalogSettings);
